var exports = {
  "DD": "xdbfd91f1--6e6fe9--title",
  "E9": "xdbfd91f1--6e6fe9--infrastructure_item",
  "kY": "xdbfd91f1--6e6fe9--infrastructure_icon",
  "Ql": "xdbfd91f1--6e6fe9--infrastructure_text",
  "OS": "xdbfd91f1--6e6fe9--more",
};

module.exports = exports;
